import {
  LearningModule,
  type LearningModuleInput
} from '@/core/domain/learning/module/LearningModule.ts'
import type { ILearningModuleRepository } from '@/core/domain/learning/module/ILearningModuleRepository.ts'

export class CreateLearningModuleUseCase {
  private readonly learningModuleRepository: ILearningModuleRepository

  constructor(learningModuleRepository: ILearningModuleRepository) {
    this.learningModuleRepository = learningModuleRepository
  }

  async execute(courseId: number, module: LearningModuleInput): Promise<LearningModule> {
    return await this.learningModuleRepository.createLearningModule(courseId, module)
  }
}
